<script>
  import { onMount, afterUpdate } from 'svelte'
  import Popup from '../components/Popup.svelte'

  let current
  let maxPuzzles
  let puzzles = {}
  export let subscription
  export let clearError

  onMount(() => {
    // clear subscription error message on component load
    clearError()
  })

  afterUpdate(() => {
    if (subscription && subscription.active && subscription.valid) {
      current = parseInt(subscription.itemCount)
      maxPuzzles = parseInt(subscription.maxPuzzles)
      for (const x of Array(maxPuzzles).keys()) {
        let idx = x + 1
        puzzles[idx] = false
        if (idx <= current) {
          puzzles[idx] = true
        }
      }
    }
  })
</script>

<style type="text/less">
  .quota {
    background: var(--col-gray-98);
    border: solid 1px var(--col-gray-90);
    border-radius: var(--border-radius);
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .quota-descr {
    padding: var(--spacing-xs) var(--spacing-sm);

    h4 {
      margin: 0;
    }

    span {
      display: block;
      font-size: 0.9em;
      line-height: var(--line-height);
    }
  }

  .quota-meter {
    text-align: center;
    padding: var(--spacing-sm);
    padding-left: 0.88rem;
    white-space: nowrap;

    .piece {
      font-size: 2rem;
      position: relative;
      left: 0.11em;
      margin-left: -0.22em;
      stroke: var(--col-gray-98);
      stroke-width: 0.5em;
      fill: var(--col-gray-80);

      &.fill {
        fill: var(--col-accent-1);
      }
    }
  }
  @media (max-width: 600px) {
    .quota {
      flex-direction: column;
    }
  }
</style>

{#if subscription && subscription.errorMsg}
  <Popup message={subscription.errorMsg} close={subscription.clearError} />
{/if}
{#if subscription && subscription.hasSubscription}
  <div class="quota">
    <div class="quota-descr">
      <h4>Your Rental Quota</h4>
      {#if !subscription.valid}
        <span>{subscription.validErrMessage}</span>
      {:else if maxPuzzles - current !== 0}
        <span>{current} out of {maxPuzzles} puzzles chosen</span>
      {:else}
        <span>
          You maxed out your quota!
          <a href="/checkout ">Checkout now!</a>
        </span>
      {/if}
    </div>

    <div class="quota-meter">
      {#each Object.keys(puzzles) as piece}
        <svg class="icon piece" class:fill={puzzles[piece] === true}>
          <use href="/icons.svg#puzzle-piece" />
        </svg>
      {/each}
    </div>
  </div>
{/if}
